export default {
  menus: [],
  pagination: {},
  menu: {}
}
